import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { isPVQForm } from 'helpers/form';
import { IdentificationSSNModel } from './types';

type ModifiedModel = Omit<IdentificationSSNModel, 'error'>
const identificationSSNValidator: ValidateJSModel<ModifiedModel> = {
  ssn: {
    presence: true,
    ssn: true,
  },
  verifiedSSN: (value, attributes) => {
    const context = { presence: true, ssn: true };
    const { ssn, verified } = attributes;
    if (ssn?.notApplicable) { return {}; }

    // If it is already verified, don't validate.
    if (verified === true) { return {}; }

    return context;
  },
  verified: (value, attributes) => {
    const context = { requireTrue: { value: true, message: 'error.ssn.mismatch' } };
    const { ssn, verifiedSSN } = attributes;
    if (ssn?.notApplicable) { return {}; }

    // If it is already verified, immediately return the validation.
    if (value === true) { return context; }

    // If the user did not complete the input, this won't return any validation.
    if (
      verifiedSSN?.first?.length !== 3
      || verifiedSSN?.middle?.length !== 2
      || verifiedSSN?.last?.length !== 4
    ) { return {}; }

    return context;
  },
  SSNNAExplanation: (value, attributes, attributeName, options) => (
    isPVQForm(options?.formType) && attributes?.ssn?.notApplicable ? { presence: true, hasValue: true } : {}
  )
};

export default identificationSSNValidator;
